import qs from 'query-string'

import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import { getApiUrl } from 'utils/apiBaseUrl'
import filterNullAndUndefinedFieldsFromObject from 'utils/filterNullAndUndefinedFieldsFromObject'

const path = '/api/user'

export const requestUserRegistration = ({ firstName, lastName, email, organisation, password, countryCode, role, CountryOfInterestId, KbaPartnerId }) => {
  return postRequest(`${path}/registration`, { firstName, lastName, email, organisation, password, countryCode, role, CountryOfInterestId, KbaPartnerId })
}

export const requestUserLogin = ({ email, password }) => {
  return postRequest(`${path}/login`, { email, password })
}

export const requestUserLogout = () => {
  return postRequest(`${path}/logout`)
}

export const requestUserChangePassword = ({ token, password }) => {
  return postRequest(`${path}/change-password`, { token, password })
}

export const requestUserResetPassword = ({ email }) => {
  return postRequest(`${path}/reset-password`, { email })
}

export const requestMyProfile = () => {
  return getRequest(`${path}/my-profile`)
}
//eslint-disable-next-line
export const requestGetUsers = ({ resultsPerPage = 8, currentPage = 1, userStatus = '', role = '', country = '', sortBy = 'lastName', sortDirection = 'ASC', signal }) => {
  const queryString = {
    resultsPerPage,
    currentPage,
    userStatus,
    role,
    country,
    sortBy,
    sortDirection
  }
  const queryStringParsed = qs.stringify(queryString)
  return getRequest(`${path}/?${queryStringParsed}`, signal)
}

export const requestChangePasswordForAuthorizedUser = ({ currentPassword, newPassword }) => {
  return postRequest(`${path}/change-password-authorized`, { currentPassword, newPassword })
}

export const requestAskChangeEmail = (email) => {
  return postRequest(`${path}/ask-change-email`, { email })
}

export const requestChangeEmail = (token) => {
  return postRequest(`${path}/change-email`, { token })
}

//eslint-disable-next-line
export const requestUsersSearch = ({ resultsPerPage = 8, currentPage = 1, query = '', sortBy = 'lastName', sortDirection = 'ASC', signal }) => {
  const queryString = {
    resultsPerPage,
    currentPage,
    query,
    sortBy,
    sortDirection
  }
  const queryStringParsed = qs.stringify(queryString)
  return getRequest(`${path}/search?${queryStringParsed}`, signal)
}
//eslint-disable-next-line
export const requestUpdateProfile = ({ organisation, countryCode, role, CountryOfInterestId, KbaPartnerId }) => {
  const body = filterNullAndUndefinedFieldsFromObject({ organisation, countryCode, role, CountryOfInterestId, KbaPartnerId })
  return postRequest(`${path}/update-profile`, body)
}

export const requestApproveRole = (userId) => {
  return postRequest(`${path}/approve-role`, { userId })
}

export const requestDeclineRole = (userId) => {
  return postRequest(`${path}/decline-role`, { userId })
}

export const requestSecretariatChangeRole = ({ userId, newRoleId }) => {
  return postRequest(`${path}/change-role`, { userId, newRoleId })
}

// eslint-disable-next-line
export const requestGetNotifications = (currentPage = 1) => {
  const queryString = {
    currentPage
  }
  const queryStringParsed = qs.stringify(queryString)
  return getRequest(`${path}/notification?${queryStringParsed}`)
}

export const requestReadNotifications = () => {
  return postRequest(`${path}/read-notification`)
}

export const generateApiKey = async () => {
  return await fetch(getApiUrl('/api/api-keys/generate'), {
    method: 'POST'
  }).then((response) => response.json())
}

export const fetchUserApiKeys = async () => {
  return await fetch(getApiUrl('/api/api-keys')).then((response) => response.json())
}

export const deleteApiKey = async () => {
  return await fetch(getApiUrl('/api/api-keys/delete'), {
    method: 'DELETE'
  })
}
